import React from 'react'

const IconDone= ({fillColor,style}) => {
  return (
    
   <svg xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
      <path d="m360.92-110.77-66.77-112.61-127.07-27.39 12.46-131.08L93.85-480l85.69-98.15-12.46-131.08 127.07-27.39 66.77-112.61L480-798.92l119.08-50.31 66.77 112.61 127.07 27.39-12.46 131.08L866.15-480l-85.69 98.15 12.46 131.08-127.07 27.39-66.77 112.61L480-161.08l-119.08 50.31ZM378-162l102-42.46L582.46-162 640-258l110-24.46L740-396l74-84-74-84.46L750-678l-110-24-58-96-102 42.46L377.54-798 320-702l-110 24 10 113.54L146-480l74 84-10 114 110 24 58 96Zm102-318Zm-42 114.31L636.31-564 608-592.77l-170 170-86-85.54L323.69-480 438-365.69Z"/>
   </svg>
  )
}
export default IconDone 